export default function BenefitsDashboardView() {
    return (
        <section>
            Dashboard admin BENEFITS
        </section>
    )
}